export default __webpack_public_path__ + "static/media/Internal data.f16fc44e.png";